import { type FC } from "react";
import { Outlet } from "react-router-dom";
import { usePreloadImages } from "../../core";
import {
  useBackgroundImages,
  FALLBACK_COLOR,
} from "../../config/background.config";
import BackgroundImage from "../../shared/components/ui/BackgroundImage/BackroundImage";
import styles from "./Backgroundlayout.module.scss";

const BackgroundLayout: FC = () => {
  const backgroundImages = useBackgroundImages();
  //   const { isLoaded, isLoading, progress, errors, getImageUrl, retry } =
  //     usePreloadImages(backgroundImages);

  //   const backgroundUrl = getImageUrl("main-background");
  //   const hasError = errors.length > 0;
  const { isImageLoaded, getImageUrl } = usePreloadImages(backgroundImages);

  const backgroundUrl = getImageUrl("main-background");
  const isLoaded = isImageLoaded("main-background");

  return (
    <div className={styles.layout}>
      <BackgroundImage
        imageUrl={backgroundUrl}
        fallbackColor={FALLBACK_COLOR}
        isLoaded={isLoaded}
        // isLoading={isLoading}
        // progress={progress}
        // hasError={hasError}
        // onRetry={retry}
      />
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};

export default BackgroundLayout;
